export default __webpack_public_path__ + "static/media/P344_CoC.42021fcc.pdf";